import { render } from "./DonorRegistryTab.vue?vue&type=template&id=2faea30b"
import script from "./DonorRegistryTab.vue?vue&type=script&lang=js"
export * from "./DonorRegistryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__